import React, { createContext, useState, useEffect, useCallback } from 'react';

export const AuthContext = createContext({
    user: null,
    setUser: () => {}, // Dodamo setUser v privzeto vrednost
    isAuthenticated: false,
    loading: true,
    loginUser: () => { },
    logoutUser: () => { },
    refreshUser: async () => { },
    unansweredCount: 0,
    refreshUnansweredCount: () => { },
});

const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [unansweredCount, setUnansweredCount] = useState(0);

    const fetchAndSetUser = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/session-user`, {
                credentials: 'include',
            });
            if (response.ok) {
                const data = await response.json();
                setUser(data.user);
            } else {
                setUser(null);
            }
        } catch (err) {
            console.error('Error fetching user data:', err);
            setUser(null);
        } finally {
            setLoading(false);
        }
    };

    const fetchUnansweredCount = useCallback(async () => {
        if (!user) return;

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/questions/unanswered/count`, {
                credentials: "include",
            });
            if (res.ok) {
                const data = await res.json();
                setUnansweredCount(data.unanswered_count);
            }
        } catch (err) {
            console.error("Failed to fetch unanswered question count", err);
        }
    }, [user]);

    useEffect(() => {
        fetchAndSetUser();
    }, []);

    useEffect(() => {
        if (user) {
            fetchUnansweredCount();
        } else {
            setUnansweredCount(0);
        }
    }, [user, fetchUnansweredCount]);

    const loginUser = (userData) => {
        setUser(userData);
    };

    const logoutUser = async () => {
        try {
            await fetch(`${process.env.REACT_APP_API_URL}/auth/logout`, {
                method: 'DELETE',
                credentials: 'include',
            });
        } catch (error) {
            console.error('Napaka med odjavo na strežniku:', error);
        } finally {
            setUser(null);
        }
    };


    const refreshUser = async () => {
        setLoading(true);
        await fetchAndSetUser();
    };

    // Sestavimo vrednost za Provider
    // --- POPRAVEK JE TUKAJ ---
    const value = {
        user,
        setUser, // Dodali smo setUser
        isAuthenticated: !!user,
        loading,
        loginUser,
        logoutUser,
        refreshUser,
        unansweredCount,
        refreshUnansweredCount: fetchUnansweredCount,
    };


    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;